import { Route } from 'react-router-dom';

import CheckoutLayout from 'src/layouts/checkout-layout';
import MainLayout from 'src/layouts/main-layout';
import CheckoutPage from 'src/pages/checkout-page';
import MainPage from 'src/pages/main-page';
import PaymentPage from 'src/pages/payment-page';
import PaymentResultPage from 'src/pages/payment-result-page';

import { AppRoute } from 'src/constants';

const MAIN_ROUTE = { path: AppRoute.MAIN_PAGE_ROUTE, component: MainPage };

const CHECKOUT_ROUTES = [
  { path: AppRoute.CHECKOUT_PAGE_ROUTE, component: CheckoutPage },
  { path: AppRoute.PAYMENT_PAGE_ROUTE, component: PaymentPage },
];

const RESULT_ROUTE = {
  path: `${AppRoute.PAYMENT_RESULT_PAGE_ROUTE}/:id`,
  component: PaymentResultPage,
};

export function MainPageRoutes() {
  const { path, component: Component } = MAIN_ROUTE;
  return <Route key={path} path={path} element={<MainLayout children={<Component />} />} />;
}

export function CheckoutRoutes() {
  return CHECKOUT_ROUTES.map(({ path, component: Component }) => (
    <Route key={path} path={path} element={<CheckoutLayout children={<Component />} />} />
  ));
}

export function ResultRoutes() {
  const { path, component: Component } = RESULT_ROUTE;
  return <Route key={path} path={path} element={<CheckoutLayout children={<Component />} />} />;
}
